import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Icon from '../../Icons'
import { getDiffColor, getPercentageDiffText } from '../helpers'
import UpsellingBlocker from '../UpsellingBlocker'
import Can from '../../Can'

const FourBlocksAnalytics = ({ data }) => {
  const { t } = useTranslation(['building-analytics'])
  const checklistsData = (data && data.checklists && data.checklists.completed) || null
  const guestsNotesData = (data && data.frontDesk && data.frontDesk.notes) || null
  const guestsVisitorsData = (data && data.frontDesk && data.frontDesk.visitors) || null
  const eventsCkeckInTotalData = (data && data.events && data.events.ckeckInTotal) || null
  const eventsSignupsTotalData = (data && data.events && data.events.signupsTotal) || null
  const totalMaintenanceRequestsData =
    (data && data.maintenance && data.maintenance.totalMaintenanceRequests) || null
  const timeToCompleteData = (data && data.maintenance && data.maintenance.timeToComplete) || null

  return (
    <div className="operation-data__four-blocks__wrapper">
      <div className="operation-statistic-row-block">
        <h3 className="title">{t('building-analytics:fourBlocksAnalytics.maintenance.title')}</h3>
        <Can
          on={'Navbar'}
          to={'maintenance'}
          feedFlag={'maintenanceRequestAvailable'}
          upsellingLink={
            <UpsellingBlocker
              type="maintenance"
              text={t('building-analytics:fourBlocksAnalytics.maintenance.upsellingText')}
              wrapperClassName="operation-statistic-row-block__upselling-blocker"
            />
          }
        >
          <React.Fragment>
            <span className="subtitle-text">
              {t('building-analytics:fourBlocksAnalytics.maintenance.completedRequests')}
            </span>
            <div className="operation-statistic-row-block__bottom-wrapper border-bottom">
              <h3 className="operation-statistic-row-block__bottom-wrapper__number">
                {totalMaintenanceRequestsData && totalMaintenanceRequestsData.value
                  ? totalMaintenanceRequestsData.value
                  : 0}
              </h3>
              {totalMaintenanceRequestsData &&
                totalMaintenanceRequestsData.percentageDiff !== '-' && (
                  <div
                    className={`operation-statistic-row-block__bottom-wrapper__percent-wrapper ${getDiffColor(
                      totalMaintenanceRequestsData,
                    )}`}
                  >
                    <span className="percent-text">
                      {getPercentageDiffText(totalMaintenanceRequestsData)}
                    </span>
                  </div>
                )}
            </div>
            <span className="subtitle-text">
              {t('building-analytics:fourBlocksAnalytics.maintenance.averageTimeToComplete')}
            </span>
            <div className="operation-statistic-row-block__bottom-wrapper">
              <h3 className="operation-statistic-row-block__bottom-wrapper__number">
                {timeToCompleteData && timeToCompleteData.value ? timeToCompleteData.value : 0}{' '}
                <span className="days-text">
                  {t('building-analytics:fourBlocksAnalytics.maintenance.daysSuffix')}
                </span>
              </h3>
              {timeToCompleteData && timeToCompleteData.percentageDiff !== '-' && (
                <div
                  className={`operation-statistic-row-block__bottom-wrapper__percent-wrapper ${getDiffColor(
                    timeToCompleteData,
                  )}`}
                >
                  <span className="percent-text">{getPercentageDiffText(timeToCompleteData)}</span>
                </div>
              )}
            </div>
            <Link className="redirect-button" to="/dashboard/building-dashboard/maintenance">
              {t('building-analytics:fourBlocksAnalytics.maintenance.goToMaintenance')}
              <Icon
                styles={{ width: '20px', paddingLeft: '5px' }}
                viewBox="0 0 20 20"
                icon={'arrowRight'}
                svgProps={{ stroke: '#646464', strokeLinecap: 'round', strokeLinejoin: 'round' }}
                fill="none"
              />
            </Link>
          </React.Fragment>
        </Can>
      </div>
      <div className="operation-statistic-row-block">
        <h3 className="title">{t('building-analytics:fourBlocksAnalytics.events.title')}</h3>
        <span className="subtitle-text">
          {t('building-analytics:fourBlocksAnalytics.events.signupsTotal')}
        </span>
        <div className="operation-statistic-row-block__bottom-wrapper border-bottom">
          <h3 className="operation-statistic-row-block__bottom-wrapper__number">
            {eventsSignupsTotalData && eventsSignupsTotalData.value
              ? eventsSignupsTotalData.value
              : 0}
          </h3>
          {eventsSignupsTotalData && eventsSignupsTotalData.percentageDiff !== '-' && (
            <div
              className={`operation-statistic-row-block__bottom-wrapper__percent-wrapper ${getDiffColor(
                eventsSignupsTotalData,
              )}`}
            >
              <span className="percent-text">{getPercentageDiffText(eventsSignupsTotalData)}</span>
            </div>
          )}
        </div>
        <span className="subtitle-text">
          {t('building-analytics:fourBlocksAnalytics.events.checkInsTotal')}
        </span>
        <div className="operation-statistic-row-block__bottom-wrapper">
          <h3 className="operation-statistic-row-block__bottom-wrapper__number">
            {eventsCkeckInTotalData && eventsCkeckInTotalData.value
              ? eventsCkeckInTotalData.value
              : 0}
          </h3>
          {eventsCkeckInTotalData && eventsCkeckInTotalData.percentageDiff !== '-' && (
            <div
              className={`operation-statistic-row-block__bottom-wrapper__percent-wrapper ${getDiffColor(
                eventsCkeckInTotalData,
              )}`}
            >
              <span className="percent-text">{getPercentageDiffText(eventsCkeckInTotalData)}</span>
            </div>
          )}
        </div>

        <Link className="redirect-button" to="/dashboard/calendar">
          {t('building-analytics:fourBlocksAnalytics.events.goToCalendar')}
          <Icon
            styles={{ width: '20px', paddingLeft: '5px' }}
            viewBox="0 0 20 20"
            icon={'arrowRight'}
            svgProps={{ stroke: '#646464', strokeLinecap: 'round', strokeLinejoin: 'round' }}
            fill="none"
          />
        </Link>
      </div>
      <div className="operation-statistic-row-block">
        <h3 className="title">
          {t('building-analytics:fourBlocksAnalytics.guestsFrontDesk.title')}
        </h3>
        <Can
          on={'Navbar'}
          to={'visitors'}
          feedFlag={'guestAccess'}
          upsellingLink={
            <UpsellingBlocker
              type="visitorManagement"
              text={t('building-analytics:fourBlocksAnalytics.guestsFrontDesk.upsellingText')}
              wrapperClassName="operation-statistic-row-block__upselling-blocker"
            />
          }
        >
          <React.Fragment>
            <span className="subtitle-text">
              {t('building-analytics:fourBlocksAnalytics.guestsFrontDesk.visitorsTotal')}
            </span>
            <div className="operation-statistic-row-block__bottom-wrapper border-bottom">
              <h3 className="operation-statistic-row-block__bottom-wrapper__number">
                {guestsVisitorsData && guestsVisitorsData.value ? guestsVisitorsData.value : 0}
              </h3>
              {guestsVisitorsData && guestsVisitorsData.percentageDiff !== '-' && (
                <div
                  className={`operation-statistic-row-block__bottom-wrapper__percent-wrapper ${getDiffColor(
                    guestsVisitorsData,
                  )}`}
                >
                  <span className="percent-text">{getPercentageDiffText(guestsVisitorsData)}</span>
                </div>
              )}
            </div>
            <span className="subtitle-text">
              {t('building-analytics:fourBlocksAnalytics.guestsFrontDesk.shiftNotesTotal')}
            </span>
            <div className="operation-statistic-row-block__bottom-wrapper">
              <h3 className="operation-statistic-row-block__bottom-wrapper__number">
                {guestsNotesData && guestsNotesData.value ? guestsNotesData.value : 0}
              </h3>
              {guestsNotesData && guestsNotesData.percentageDiff !== '-' && (
                <div
                  className={`operation-statistic-row-block__bottom-wrapper__percent-wrapper ${getDiffColor(
                    guestsNotesData,
                  )}`}
                >
                  <span className="percent-text">{getPercentageDiffText(guestsNotesData)}</span>
                </div>
              )}
            </div>

            <Link className="redirect-button" to="/dashboard/building-dashboard/visitors">
              {t('building-analytics:fourBlocksAnalytics.guestsFrontDesk.goToGuestsFrontDesk')}
              <Icon
                styles={{ width: '20px', paddingLeft: '5px' }}
                viewBox="0 0 20 20"
                icon={'arrowRight'}
                svgProps={{ stroke: '#646464', strokeLinecap: 'round', strokeLinejoin: 'round' }}
                fill="none"
              />
            </Link>
          </React.Fragment>
        </Can>
      </div>
      <div className="operation-statistic-row-block">
        <h3 className="title">{t('building-analytics:fourBlocksAnalytics.checklists.title')}</h3>
        <Can
          on={'Navbar'}
          to={'checklists'}
          feedFlag={'checklistsAvailable'}
          upsellingLink={
            <UpsellingBlocker
              type="checklists"
              text={t('building-analytics:fourBlocksAnalytics.checklists.upsellingText')}
              wrapperClassName="operation-statistic-row-block__upselling-blocker"
            />
          }
        >
          <React.Fragment>
            <span className="subtitle-text">
              {t('building-analytics:fourBlocksAnalytics.checklists.completedChecklists')}
            </span>
            <div className="operation-statistic-row-block__bottom-wrapper">
              <h3 className="operation-statistic-row-block__bottom-wrapper__number">
                {checklistsData && checklistsData.value ? checklistsData.value : 0}
              </h3>
              {checklistsData && checklistsData.percentageDiff !== '-' && (
                <div
                  className={`operation-statistic-row-block__bottom-wrapper__percent-wrapper ${getDiffColor(
                    checklistsData,
                  )}`}
                >
                  <span className="percent-text">{getPercentageDiffText(checklistsData)}</span>
                </div>
              )}
            </div>
            <Link className="redirect-button" to="/dashboard/building-dashboard/checklists">
              {t('building-analytics:fourBlocksAnalytics.checklists.goToChecklists')}
              <Icon
                styles={{ width: '20px', paddingLeft: '5px' }}
                viewBox="0 0 20 20"
                icon={'arrowRight'}
                svgProps={{ stroke: '#646464', strokeLinecap: 'round', strokeLinejoin: 'round' }}
                fill="none"
              />
            </Link>
          </React.Fragment>
        </Can>
      </div>
    </div>
  )
}

FourBlocksAnalytics.propTypes = {
  data: PropTypes.object,
}
export default FourBlocksAnalytics
